import { Typography } from '../../../widgets/Typography';
import ActiveMembersSyncView from './ActiveMembersSyncView';

export default function MemberLifeCycleManagement() {
  return (
    <div className="bg-gold-200 flex flex-col pt-8 pr-8">
      <div className="flex flex-col">
        <Typography
          variant="display-sm"
          weight="semibold"
          className="text-left"
        >
          Member Management
        </Typography>
        <Typography
          variant="body-md"
          weight="regular"
          className="text-grey-700 text-left"
        >
          Manage your team members and their lifecycle within your organization.
        </Typography>
      </div>
      <div className="mt-8">
        <ActiveMembersSyncView />
      </div>
    </div>
  );
}
